import { __decorate } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import C7nSkeletonInput from '../../../lib/skeleton/Input';
import DataSetComponent from '../data-set/DataSetComponent';
let SkeletonInput = class SkeletonInput extends DataSetComponent {
    render() {
        const { ...otherProps } = this.props;
        const props = {};
        return React.createElement(C7nSkeletonInput, Object.assign({}, otherProps, props));
    }
};
SkeletonInput.displayName = 'SkeletonInput';
SkeletonInput = __decorate([
    observer
], SkeletonInput);
export default SkeletonInput;
